import React, { useEffect, useState, useMemo } from "react";

import Table from "../components/table/Table";

import Modal from "../components/modal/Modal";
import { Box } from "@mui/system";
import UserEntry from "./user/UserEntry";
import { useDispatch, useSelector } from "react-redux";
import { editUserPassword, fetchAllusers } from "../redux/features/user.features";
import { Link } from "react-router-dom";
import StatusCard from "../components/status-card/StatusCard";
import { Button, ButtonGroup, TextField } from "@mui/material";
import CustomSelectBox from "../components/CustomSelectBox/CustomSelectBox";

const userTableHead = [
  "user Id",
  "user Name",
  "user email",
  "password",
  "role",
  "Register Date",
   
  "Status",
  "Actions",
];

const renderHead = (item, index) => <th key={index}>{item}</th>;

const initialValues = {
  userId: "",
  email: "",
  password: "",
  role: "",
  registerDate: "",   
  status: "",
};

const Users = () => {
  const dispatch = useDispatch();

  const [values, setValues] = useState(initialValues);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  const [selectedData, setselectedData] = React.useState(null);
  const [showModal, updateShowModal] = React.useState(false);
  const toggleModal = () => {
    updateShowModal((state) => !state);
    dispatch(fetchAllusers());
  };

  const [showEditModal, updateShowEditModal] = React.useState(false);
  const toggleEditModal = () => {
    updateShowEditModal((state) => !state);
    dispatch(fetchAllusers());
  };

  const [showManage, updateshowManage] = React.useState(false);
  const toggleManage = () => {
    updateshowManage((state) => !state);
    dispatch(fetchAllusers());
  };

  const renderBody = (item, index) => (
    <tr key={index}>
      {/* <td>{item.id}</td> */}
      <td>{item.userId}</td>
      <td>{item.userName}</td>
      <td>{item.email}</td>
      <td>{item.password}</td>
      <td>{item.role}</td>
      <td>{item.registerDate}</td>
       

     
      <td>
        {String(item.status).toLowerCase() === "active" ? (
          <p className="p-1 py-2 bg-green-500 rounded">{item.status}</p>
        ) : (
          <p className="p-1 py-2 bg-red-700 rounded">{item.status}</p>
        )}
      </td>
      {
        showManage && ( <td className="text-right flex items-center">
        <div
          onClick={() => {
            toggleEditModal();
            setselectedData(item);
          }}
          className="bg-red-500 rounded p-2 bx bx-edit mx-2"
        ></div>
        <div  onClick={() => {
           changePassword(item)
          }}className="bg-green-500 rounded p-2 bx bx-compass mx-2"></div>
      </td>)
      }
     
    </tr>
  );

  const changePassword = (item)=>{
   
   var newPassword = prompt("Enter new password")

   if(newPassword && newPassword !==""){
    const d={
      id: item.id,
      password: newPassword
    }
    console.log("password  changing..", d)
    dispatch(editUserPassword(d))

    alert("Password Changed successfully")
   }
   
  }

  useEffect(() => {
    dispatch(fetchAllusers());
  }, [dispatch]);

  let userState = useSelector((state) => {
    return state.userReducer;
  });

  let { users, loading } = userState;

  useEffect(() => {}, [users]);
  const memorizedUserData = useMemo(() => users, [users])

  return (
    <div>
      {/* <h2 className="page-header ">
        <i className="bx bx-plus page-header__icon"></i>
        
      </h2>
        */}

      <div className="row">
        <div className="col-3">
          <StatusCard
            icon={"bx bx-user"}
            count={users.length}
            title={"users"}
          ></StatusCard>
        </div>
      </div>
      <div className="flex items-center my-3   justify-evenly">
        <div
          onClick={toggleModal}
          className="col-3 sidebar__item cursor-pointer m-0"
        >
          <div className={`sidebar__item-inner active`}>
            <i className="bx bx-plus"></i>
            <span>Create New User</span>
          </div>
        </div>
        <div
          onClick={toggleManage}
          className="col-3 sidebar__item cursor-pointer m-0"
        >
          <div className={`sidebar__item-inner active`}>
            <i className="bx bx-search-alt"></i>
            <span className="flex justify-between items-center">Manage User
            {!showManage ? (
              <span
                style={{
                  fontSize: "x-large",
                  margin: "0px 20px",
                  padding: "5px",
                  boxShadow: "rgb(0 0 0 / 30%) 0px 1px 10px",
                }}
                className="bx bx-arrow-to-right rounded-full"
              ></span>
            ) : (
              <span
                style={{
                  fontSize: "x-large",
                  margin: "0px 20px",
                  padding: "5px",
                  boxShadow: "rgb(0 0 0 / 30%) 0px 1px 10px",
                }}
                className="bx bx-arrow-to-bottom bg-amber-400 rounded-full"
              ></span>
            )}
              
            </span>
          
          </div>
        </div>
      </div>
      {showManage ? (
        <div style={{background:"var(--main-bg)"}} className="flex   flex-wrap items-center my-6   p-5">
          <div className="flex m-2 p-2">
            <TextField
              style={{ color: "white", marginBottom: 24, marginRight: 10 }}
              required
              id="outlined-required"
              label="User id"
              defaultValue=""
              color="warning"
              margin="dense"
              name="userId"
              value={values.userId}
              onChange={handleChange}
            />
          </div>

          <div className="flex m-2 p-2">
            <TextField
              style={{ color: "white", marginBottom: 16, marginRight: 10 }}
              required
              id="outlined-required"
              label="userName"
              placeholder="userName..."
              name="userName"
              defaultValue=""
              color="warning"
              onChange={handleChange}
              value={values.userName}
            />
          </div>
          <div className="flex m-2 p-2">
            <TextField
              style={{ color: "white", marginBottom: 16, marginRight: 10 }}
              required
              id="outlined-required"
              label="startDate"
              placeholder="startDate"
              defaultValue=""
              color="warning"
              name="startDate"
              value={values.startDate}
              onChange={handleChange}
            />
          </div>
          <div className="flex m-2 p-2 w-2/12">
            <CustomSelectBox
              items={[
                "Sri Lanka",
                "Singapore",
                "Tanzania",
                "USA",
                "UK",
                "Madagascar",
              ]}
              onChange={handleChange}
              title="fromCountry"
              name="fromCountry"
              value={values.fromCountry}
            />
          </div>

          <div className="flex m-2 p-2 w-2/12">
            <CustomSelectBox
              items={[
                "Sri Lanka",
                "Singapore",
                "Tanzania",
                "USA",
                "UK",
                "Madagascar",
              ]}
              onChange={handleChange}
              title="toCountry"
              name="toCountry"
              value={values.toCountry}
            />
          </div>

          <div className="flex w-full">
            <ButtonGroup
              fullWidth
              variant="contained"
              aria-label="outlined primary button group"
              style={{ marginTop: 15 }}
            >
              <Button
                style={{ padding: 15, fontSize: "1rem" }}
                onClick={() => {
                  setValues(initialValues);
                  // setEnterDate("");
                  // search()
                }}
                color="warning"
              >
                Clear
              </Button>
              <Button
                style={{ padding: 15, fontSize: "1rem" }}
                // onClick={search}
                color="success"
              >
                Search
                <i
                  style={{ padding: 5, fontSize: "1rem" }}
                  className="bx bx-search-alt"
                ></i>
              </Button>
            </ButtonGroup>
          </div>
        </div>
      ) : null}

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card__body">
              {loading ? (
                <p>loading...</p>
              ) : (
                <Table
                  limit="10"
                  headData={userTableHead}
                  renderHead={(item, index) => renderHead(item, index)}
                  bodyData={memorizedUserData}
                  renderBody={(item, index) => renderBody(item, index)}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        modal_title={"Create new user"}
        canShow={showModal}
        updateModalState={toggleModal}
        
      >
        <UserEntry cancel={toggleModal} />
      </Modal>
      <Modal
        modal_title={"Edit User Information"}
        canShow={showEditModal}
        updateModalState={toggleEditModal}
      >
        <UserEntry
          data={selectedData}
          editMod={true}
          cancel={toggleEditModal}
        />
      </Modal>
    </div>
  );
};

export default Users;
